var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfoFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.996 0c3.207 0 6.22 1.248 8.487 3.514A11.917 11.917 0 0124 12a11.92 11.92 0 01-3.517 8.486A11.927 11.927 0 0111.996 24c-3.207 0-6.221-1.249-8.487-3.514-4.679-4.68-4.679-12.292 0-16.972A11.923 11.923 0 0111.996 0zm.007 10H10a1 1 0 000 2h1v5h-1a1 1 0 000 2h4.003a1 1 0 000-2h-1v-6a1 1 0 00-1-1zm-.501-5a1.5 1.5 0 10-.002 3h.002l.145-.006A1.5 1.5 0 0011.502 5z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconInfoFilled;